var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEnergy = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3149 7.66546H14.1705C14.8455 7.66579 15.4655 8.04529 15.7837 8.65291C16.102 9.26052 16.0669 9.99763 15.6923 10.5708L12.0362 16.1684C11.5889 16.8532 10.7552 17.1583 9.98363 16.9196C9.21204 16.6808 8.68456 15.9545 8.68503 15.1315V12.3344H5.82943C5.1545 12.3341 4.53453 11.9546 4.21627 11.347C3.89801 10.7394 3.93312 10.0024 4.30762 9.42917L7.96376 3.83163C8.411 3.14681 9.24473 2.84169 10.0163 3.08043C10.7879 3.31917 11.3154 4.04548 11.3149 4.86853V7.66546Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEnergy);
export default ForwardRef;